import Multiselect from "multiselect-react-dropdown";
import React, { useContext, useEffect, useRef, useState } from "react";
import { Button } from "react-bootstrap";
import { withTranslation } from "react-i18next";
import { toast } from "react-toastify";
import { RegulationContext } from "../../../App";
import ReportingPeriod from "../../../components/Regulation/ReportingPeriod";
import { CategoryList, CompareCategoryType, DataViewCategoryType, StandardCategory } from "../../../core/constants/common";
import CompanyService from "../../../core/service/CompanyService";
import FormService from "../../../core/service/FormService";
import StandardService from "../../../core/service/StandardService";
import Utils from "../../../core/utilities/Utils";


const ExpImpFilter = ({ t, onApplyFilter, onResetFilter, viewFilter, onFilterHide }) => {

    const [viewType, setViewType] = useState('DATA_VIEW');
    const { glbRegulation } = useContext(RegulationContext);
    const glbRegulationId = glbRegulation?.id ?? "";
    const month = Utils.getMonthFromFrequency(glbRegulation.frequency);
    const year = new Date().getFullYear();

    const [filter, setFilter] = useState({
        reportingPeriod: `${year}-${month}-01`,
        categoryType: DataViewCategoryType.ENVIRONMENTAL,
        topicIds: [],
        metricIds: [],
        businessUnitIds: [],
        parentEntities: [],
        childEntities: [],
        periodFrom: `${year}-01-01`,
        periodTo: `${year}-12-31`,
        groupIds: [],
        periodType: 'YEARLY',
        period: null,
    });
    const [topics, setTopics] = useState([]);
    const [parentEntities, setParentEntities] = useState([]);
    const [childEntities, setChildEntities] = useState([]);
    const [groups, setGroups] = useState([]);
    const [displayFilter, setDisplayFilter] = useState(true);

    const topicsRef = useRef();
    const patentEntRef = useRef();
    const childEntRef = useRef();
    const enterpriseRef = useRef();

    useEffect(() => {
        if (!glbRegulationId) return;
        getTopics();
        getEnterprisesByLevel(1);
        getEnterprisesByLevel(2);
        getGroups();
    }, [glbRegulationId]);

    useEffect(() => {
        setDisplayFilter(viewFilter);
    }, [viewFilter]);

    const getTopics = () => {
        StandardService.getTopicsByStandard(glbRegulationId, false, StandardCategory.QUANTITATIVE, filter.categoryType)
            .then(res => {
                if (res.status !== 200) return;

                setTopics(res.data);
            }).catch(err => { });
    };

    const getEnterprisesByLevel = (level) => {
        CompanyService.getEnterprisesByLevel(level).then(res => {
            if (res.status !== 200) return;

            const entities = res.data.sort((a, b) => a.sortOrder - b.sortOrder);
            if (level === 1) {
                setParentEntities(entities);
            } else if (level === 2) {
                setChildEntities(entities);
            }
        }).catch(err => { });
    };

    const getGroups = () => {
        FormService.listGroups().then(res => {
            if (res.status !== 200) return;

            setGroups(res.data);
        }).catch(err => { });
    };

    const onSelectDeSelectTopic = (selectedItem) => {
        const topicIds = [...filter.topicIds];
        const index = filter.topicIds.indexOf(selectedItem.id);
        if (index >= 0) {
            topicIds.splice(index, 1);
        } else {
            topicIds.push(selectedItem.id);
        }
        setFilter({
            ...filter,
            topicIds: topicIds,
            metricIds: [],
        });
    };

    const getSelectedTopics = () => {
        const data = [];
        topics?.forEach(topic => {
            if (filter.topicIds.indexOf(topic.id) < 0) return;

            data.push(topic);
        });
        return data;
    };

    const onSelectDeSelectParentEntity = (item) => {
        const entities = [...filter.parentEntities];
        const index = filter.parentEntities.indexOf(item.id);
        if (index >= 0) {
            entities.splice(index, 1);
        } else {
            entities.push(item.id);
        }
        setFilter({
            ...filter,
            parentEntities: entities
        });
    };

    const onSelectDeSelectChildEntity = (item) => {
        const entities = [...filter.childEntities];
        const index = filter.childEntities.indexOf(item.id);
        if (index >= 0) {
            entities.splice(index, 1);
        } else {
            entities.push(item.id);
        }
        setFilter({
            ...filter,
            childEntities: entities
        });
    };

    const onSelectDeSelectGroup = (item) => {
        const groupIds = [...filter.groupIds];
        const index = filter.groupIds.indexOf(item.id);
        if (index >= 0) {
            groupIds.splice(index, 1);
        } else {
            groupIds.push(item.id);
        }
        setFilter({
            ...filter,
            groupIds: groupIds
        });
    };

    const getSelectedParentEntities = () => {
        const data = [];
        parentEntities?.forEach(p => {
            if (filter.parentEntities.indexOf(p.id) < 0) return;

            data.push(p);
        });
        return data;
    };

    const getSelectedChildEntities = () => {
        const data = [];
        childEntities?.forEach(c => {
            if (filter.childEntities.indexOf(c.id) < 0) return;

            data.push(c);
        });
        return data;
    };

    const applyFilter = () => {
        const filterData = JSON.parse(JSON.stringify(filter));
        filterData.businessUnitIds = [];
        filterData.parentEntities?.forEach(e => {
            filterData.businessUnitIds.push(e)
        });
        filterData.childEntities?.forEach(e => {
            filterData.businessUnitIds.push(e)
        });
        if ((filterData.parentEntities.length > 0 || filterData.childEntities.length > 0) && filterData.topicIds.length > 0) {
            onApplyFilter(filterData);
        } else {
            toast.warning('Select any parent or child entity along with topic', {
                position: toast.POSITION.TOP_RIGHT,
                autoClose: 2000
            });
        }
        console.log(filterData);
    };

    const resetFilter = () => {
        setFilter({
            reportingPeriod: `${year}-${month}-01`,
            categoryType: DataViewCategoryType.ENVIRONMENTAL,
            topicIds: [],
            metricIds: [],
            businessUnitIds: [],
            parentEntities: [],
            childEntities: [],
            periodFrom: `${year}-01-01`,
            periodTo: `${year}-12-31`,
            groupIds: [],
            periodType: 'YEARLY',
            period: null,
        });
        onResetFilter();
        resetValues();
    };

    const resetValues = () => {
        topicsRef?.current?.resetSelectedValues();
        patentEntRef?.current?.resetSelectedValues();
        childEntRef?.current?.resetSelectedValues();
        enterpriseRef?.current?.resetSelectedValues();
    }

    const renderReportingPeriodFilter = () => {
        return (
            <>
                <div className="col-lg-12 p-2">
                    <label>{t("ReportingPeriod.label")}</label>
                    <ReportingPeriod
                        defaultPeriod={filter.reportingPeriod}
                        valueChangeCallback={(period) =>
                            setFilter({ ...filter, reportingPeriod: `${period.year}-${period.month}-01` })
                        } />
                </div>
            </>
        );
    };

    const renderMetricRelatedFilters = () => {
        return (
            <>
                <div className="col-lg-12 p-2">
                    <label htmlFor="esgFilter">{t("Category.label")}</label>
                    <select id="esgFilter"
                        className="form-select"
                        onChange={(e) => setFilter({ ...filter, categoryType: +e.target.value, topicIds: [], metricIds: [] })}
                        required
                        value={filter.categoryType}>
                        {
                            CategoryList({ t }).map(c => {
                                return <option value={c.id} key={c.key}>{c.text}</option>
                            })
                        }
                    </select>
                </div>
                <div className="col-lg-12 p-2">
                    <label>{t("Topic.label")}</label>
                    <Multiselect
                        id="topicMultiSelect"
                        key="topicMultiSelect"
                        ref={topicsRef}
                        options={topics}
                        selectedValues={getSelectedTopics()}
                        selectionLimit={viewType == 'COMPARE' ? 5 : null}
                        onSelect={(selectedList, selectedItem) => {
                            onSelectDeSelectTopic(selectedItem);
                        }}
                        onRemove={(selectedList, selectedItem) => {
                            onSelectDeSelectTopic(selectedItem);
                        }}
                        placeholder={getSelectedTopics().length === 0 ? t("Select.label") : ""}
                        displayValue="name"
                        style={{ chips: { maxWidth: '200px', whiteSpace: 'normal' } }}
                    />
                </div>
                <div className="col-lg-12 p-2">
                    <label>{t("ParentEntity.label")}</label>
                    <Multiselect
                        id={`parentEntityMultiselect`}
                        key={`parentEntityMultiselect`}
                        options={parentEntities}
                        ref={patentEntRef}
                        selectedValues={getSelectedParentEntities()}
                        selectionLimit={viewType == 'COMPARE' ? 5 : null}
                        onSelect={(selectedList, selectedItem) => {
                            onSelectDeSelectParentEntity(selectedItem);
                        }}
                        onRemove={(selectedList, selectedItem) => {
                            onSelectDeSelectParentEntity(selectedItem);
                        }}
                        placeholder={getSelectedParentEntities().length === 0 ? t("Select.label") : ""}
                        displayValue="name"
                        style={{ chips: { maxWidth: '200px', whiteSpace: 'normal' } }}
                    />
                </div>
                <div className="col-lg-12 p-2">
                    <label>{t("ChildEntity.label")}</label>
                    <Multiselect
                        id={`childEntityMultiselect`}
                        key={`childEntityMultiselect`}
                        options={childEntities}
                        ref={childEntRef}
                        selectedValues={getSelectedChildEntities()}
                        selectionLimit={viewType == 'COMPARE' ? 5 : null}
                        onSelect={(selectedList, selectedItem) => {
                            onSelectDeSelectChildEntity(selectedItem);
                        }}
                        onRemove={(selectedList, selectedItem) => {
                            onSelectDeSelectChildEntity(selectedItem);
                        }}
                        placeholder={getSelectedChildEntities().length === 0 ? t("Select.label") : ""}
                        displayValue="name"
                        style={{ chips: { maxWidth: '200px', whiteSpace: 'normal' } }}
                    />
                </div>
            </>
        );
    };

    const populateEntities = (children, nodes) => {
        children?.forEach(child => {
            nodes.push(child);
            if (child?.children?.length > 0) {
                populateEntities(child.children, nodes);
            }
        });
    };

    return (
        <div>
            {
                displayFilter &&
                <div className="filter-holder 4">
                    {/* <div className="filter-holder_head ">
                        <h5>{t("Filter.label")}</h5>
                    </div> */}
                    <div className="filter-holder_body">
                        {renderReportingPeriodFilter()}
                        {renderMetricRelatedFilters()}
                    </div>
                    <div className="filter-holder_footer p-2 text-center">
                        {/* <Button variant="secondary"
                            onClick={() => onFilterHide(false)}
                            className="px-4 mx-2">
                            {t("Cancel.label")}
                        </Button> */}
                        <Button variant="primary"
                            onClick={() => applyFilter()}
                            className="sbmBtn px-4">
                            {t("Download.label")}
                        </Button>
                        <Button variant="secondary"
                            onClick={() => resetFilter()}
                            className="px-4 mx-2">
                            {t("Reset.label")}
                        </Button>

                    </div>
                </div>
            }
        </div>
    );
};

export default withTranslation()(ExpImpFilter);
